/**
 * Maps an application's lobType (returned from the backend on
 * ApplicationInGroup) to a user-facing product label shown in the Coverages
 * card header, e.g. "Recommended {label} Policy:".
 *
 * lobType is an open-ended string from the backend; unknown values fall back
 * to the raw lobType so they remain visible rather than rendering blank.
 */

/* Not used at this moment, will use when E&O actually comes */
export const lobTypeToProductLabel = (lobType: string): string => {
  switch (lobType) {
    case 'GL':
      return 'Commercial General Liability';
    case 'EO':
      return 'Professional Liability';
    default:
      return lobType;
  }
};
